export const version = {
  "version": "1.0.0",
  "hash": "1793718084870319"
};
